import React from 'react';
import PropTypes from 'prop-types';
import { ToolbarGroup } from 'material-ui/Toolbar';
import translate from 'components/hoc/translate';

const PaginationAmount = (props) => {
    const {
        offsetBegin,
        offsetEnd,
        total,
        translate,
    } = props;

    return (
        <ToolbarGroup>
            <span className='displayed-records'>
                {
                    translate('aor.navigation.page_range_info', {
                        offsetBegin: offsetBegin,
                        offsetEnd: offsetEnd,
                        total: total,
                    })
                }
            </span>
        </ToolbarGroup>
    );
};

PaginationAmount.propTypes = {
    offsetBegin: PropTypes.number.isRequired,
    offsetEnd: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(PaginationAmount);



// WEBPACK FOOTER //
// ./src/components/list/Pagination/PaginationAmount.js